<div class="open-footer padding-vertical-medium">
  <div class="grid grid-wrapper grid-elastic">
    <div *ngIf="showLegalInfo && !hideDisclaimer" class="open-footer-disclaimer cell cell-large-col-span-12">
      <div class="text-xsmall" [innerHTML]="(showProductDisclaimer && partnerBrandData && partnerBrandData.product && partnerBrandData.product.disclaimer) || (partnerBrandData && partnerBrandData.disclaimer) || DEFAULT_DISCLAIMER"></div>
    </div>

    <div class="cell cell-large-col-span-8 cell-medium-col-span-6 cell-small-col-span-3 cell-tiny-col-span-2">
      <div class="open-footer-links">
        <div *ngIf="!showLegalInfo && !hideDisclaimer" class="text-xsmall">
          <a href (click)="onShowLegalInfo()">Important legal info</a>
        </div>
        
        <div class="text-xsmall open-footer-terms-link" *ngIf="partnerBrandData">
          <a [href]="(partnerBrandData && partnerBrandData.companyInfo && partnerBrandData.companyInfo.TERMS_URL) || '/terms'" target="_blank">{{ termsLabel }}</a>
        </div>
        <div class="text-xsmall open-footer-privacy-link" *ngIf="partnerBrandData">
          <a [href]="(partnerBrandData && partnerBrandData.companyInfo && partnerBrandData.companyInfo.PRIVACY_URL) || '/terms'" target="_blank">Privacy</a>
        </div>
      </div>
    </div>

    <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-2">
      <div class="open-logo">
        <open-svg-logo name="powered-by-open" class="grey height-20 width-105"></open-svg-logo>
      </div>
    </div>
  </div>
</div>
